// @ts-strict-ignore
import { Badge } from '@usealloy/component-library';

import type {
  Option,
  Props as DropdownFacetProps,
} from '~/queries/DropdownFacet/DropdownFacet';
import { buildOutcomeBadgeProps } from '~/utils/outcomes';

interface Props {
  displayOutcome?: boolean;
  facet?: DropdownFacetProps['facet'];
  option?: Option;
  value?: string;
}

export default function OptionBadge({
  displayOutcome = false,
  facet = {} as DropdownFacetProps['facet'],
  option = {} as Option,
  value,
}: Props) {
  const { props: outcomeProps, text: outcomeText } = buildOutcomeBadgeProps({
    label: value ?? option.value,
    outcomeColor: option?.outcome_color,
    outcomeIcon: option?.icon_name,
  });

  if (facet.key === 'outcome') {
    return (
      <Badge {...outcomeProps} iconSize="small">
        {displayOutcome && outcomeText}
      </Badge>
    );
  }

  if (option.fa) {
    return (
      <i className={option.fa.className} style={option.fa.style} />
    );
  }

  return null;
}
